// Single domain source for currency codes used across royalty screens.
//
// The DB `currency_code` enum is broader, but the royalty engine can only value a
// non-RUB amount when a positive FX rate exists (P0: no rate ⇒ blocking
// `FX_MISSING`, never a silent 1:1). So the meaningful domain for a royalty term /
// charge / payment is the FX-supported set — RUB plus the currencies covered by
// `get_fx_rate_to_rub` (see `fx_daily_rates`, docs/CURRENCY_AND_MONTHLY_ANALYTICS_PLAN.md).
//
// Ordered most-used first (RUB, then USD/EUR/AED), then the remaining revenue
// currencies alphabetically. Adding a currency here without FX coverage would let
// an operator pick a term currency the engine can't bill — keep this list ⊆ FX set.
export const ROYALTY_CURRENCY_CODES = [
  'RUB',
  'USD',
  'EUR',
  'AED',
  'AMD',
  'AUD',
  'BYN',
  'KGS',
  'KZT',
  'MDL',
  'PLN',
  'RON',
  'RSD',
  'TRY',
] as const

export type RoyaltyCurrencyCode = (typeof ROYALTY_CURRENCY_CODES)[number]
